import { Components, Theme } from "@mui/material";

export const MuiCardContent: Components<
  Omit<Theme, "MuiCardContent">
>["MuiCardContent"] = {
  defaultProps: {
    sx: {
      padding: 3,
    },
  },
};
